import React from "react";
import { useContractKit } from "@celo-tools/use-contractkit";
import { Box, Button, Container, Text, Flex, Spacer } from "@chakra-ui/react";
import Footer from "./footer";
import Header from "./header";

function Layout({ children }) {
  const { connect, destroy, address, kit, performActions } = useContractKit();
  const walletConnected = address?.length > 0;

  function connectWallet() {
    if (walletConnected) return;
    try {
      connect();
    } catch (err) {
      console.log(err);
    }
  }

  function disconnectWallet() {
    if (!walletConnected) return;
    try {
      destroy();
    } catch (err) {
      console.log(err);
    }
  }
  return (
    <Flex flexDir="column" backgroundColor="#19323C" textColor="white" justifyContent='center'>
      <Header />
      <Flex justifyContent="end">
        <Box
          mr={8}
          p={6}
          borderWidth={2}
          borderColor={"gray.500"}
          borderRadius={"md"}
        >
          <Box mb={4}>
            {!walletConnected ? (
              <Button
                colorScheme={"green"}
                onClick={connectWallet}
                disabled={walletConnected}
                size={"sm"}
              >
                Connect Wallet
              </Button>
            ) : (
              <Button
                colorScheme={"yellow"}
                onClick={disconnectWallet}
                disabled={!walletConnected}
                size={"sm"}
              >
                Disconnect Wallet
              </Button>
            )}
          </Box>
          <Box>
            <Text>{address?.substring(0, 12)}...</Text>
          </Box>
        </Box>
      </Flex>
      <Container my={20} minHeight="70vh" maxW="100vw" pl='20' pr='20' justifyContent='center'>
        {children}
      </Container>
      <Footer />
    </Flex>
  );
}

export default Layout;
